(function(){
     'use strict';

     angular
        .module('app')
        .factory('StripeService', StripeService);

    StripeService.$inject = ['$uibModal', '$http','UserService','AddressService'];

    function StripeService($uibModal, $http,UserService,AddressService){

        var stripe = Stripe( 'pk_live_4PwOGHjbnxb56xV50VfY9Qig' , { locale: 'en'} );
        var card  = null;
        var elements = null;
        /*
        https://stripe.com/docs/testing
        No authentication (default U.S. card): 4242 4242 4242 4242.
        Authentication required: 4000 0027 6000 3184.
        */

        var vm= {
           
            amount:0,
            items:[],
            fullname: "",
            error:false,
            errorMsg:"",
            products:{},
            document_id:null,
            currency:'$',
            cardError:false

        };

        vm.clear = function(){
            vm.products = {};
            vm.amount = 0;
            vm.fullname = '';
            vm.init();
        };

        vm.setAmount=function(amount)
        {
            vm.amount = amount;
        };

        vm.addProduct = function(key,amount)
        {
            if(amount>0)
                vm.products[key]= amount;
        };

        vm.setProducts = function(products)
        {
            angular.forEach(products,function(value,key){
                if(value>0)
                  vm.products[key]= value;
            });
        };
        //set Address service
        vm.as = AddressService;


        vm.init = function()
        {
            elements = stripe.elements();
            var style = {
                    base: {
                    // Add your base input styles here. For example:
                        lineHeight: '1.429'
                    },
            };
            // Create an instance of the card Element.
            card = elements.create('card', {style: style});
            // Add an instance of the card Element into the `card-element` <div>.
            card.mount('#card-element');

            card.on('change', function(event) {
                  
                  if (event.error) {
                    vm.cardError = true;  
                  } else {
                     vm.cardError = false;
                  }
            }); 

        };


        vm.submitForm = function(valid)
        {
            

            var config = {
                        headers : {
                            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                            'Cache-Control' : 'no-cache'
                        }
                    };
                    var data = $.param({
                           amount:vm.amount,
                           lang_id:lang_id,
                           currency:vm.currency
                    });
                   return  $http.post('/middleware/payment', data, config)
                        .then(function(data){

                            return stripe.confirmCardPayment(data.data.clientSecret, {
                                  payment_method: {
                                    card: card
                                  }
                            }).then(function(result) {
                                console.log(result);
                                  if (result.error) {
                                        // Show error to your customer
                                        //showError(result.error.message);
                                        vm.error =  true;
                                        vm.errorMsg =  result.error.code;
                                        return result;

                                  } else {
                                      vm.error =  false;
                                    // The payment succeeded!
                                    //orderComplete(result.paymentIntent.id);
                                    return vm.orderComplete(result);
                                  }

                            });
                });
        };

        vm.orderComplete = function(r)
        {
            return UserService.userPayment({
                amount:vm.amount,
                products:vm.products,
                payment:r,
                address:parseInt(vm.as.addressShipping),
                currency:vm.currency
            }).then(function(data){
                console.log(data);

                vm.openSaved();
                vm.clear();
                return data;
            });
        };


         vm.PaymentWithDoc = function(){
             console.log("ENTRAMOS");
              return UserService.userPaymentWithDoc({
                  amount:vm.amount,
                  products:vm.products,
                  payment:null,
                  address:parseInt(vm.as.addressShipping),
                  document:vm.document_id,
                  currency:vm.currency
              }).then(function(data){
                  console.log(data);

                  vm.openSavedDoc();
                  vm.clear();
                  return data;
              });
        };



        vm.savedModalDoc = "";

        vm.openSavedDoc = function(){
            vm.savedModalDoc = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'okpaymentstudent.html',
                  size: 'sm',
                  //backdrop:'static',
                  controller: function($scope) {
                    $scope.closeForm = function(){
                      vm.savedModalDoc.close();
                    };
                }
            });
        };

        vm.savedModal = "";

        vm.openSaved = function(){
            vm.savedModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'okpayment.html',
                  size: 'sm',
                  //backdrop:'static',
                  controller: function($scope) {
                    $scope.closeForm = function(){
                      vm.savedModal.close();
                    };
                }
            });
        };

         vm.message = "";

        vm.openMsg = function(title,subtitle,msg){
            vm.message = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'message.html',
                  size: 'sm',
                  //backdrop:'static',
                  controller: function($scope) {
                     $scope.title = title;
                     $scope.subtitle = subtitle;
                     $scope.msg = msg;
                    $scope.closeForm = function(){
                      vm.message.close();
                    };
                }
            });
        };

        vm.paymentModal = "";

        vm.openPaymentModal = function(invoice){
            vm.paymentModal = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'payment.html',
                  size: 'sm',
                  //backdrop:'static',
                  controller: function($scope) {
                     $scope.amount = invoice.total;
                     $scope.as = AddressService;
                     $scope.invoice = invoice;

                    $scope.closeForm = function(){
                      vm.paymentModal.close();
                    };
                }
            });
        };




        return vm;

        
        


    

       

    }
})();